import _ from 'lodash';

import {CategoryData, ServicesData} from 'models/app';
import {getFlatMap} from 'utils/data';

export const getMenuItems = _.memoize((categories: CategoryData[]) => {
    return categories.map(({slug, name}) => ({text: name, url: slug}));
});

export function transformServicesData(servicesData: ServicesData) {
    const flatMap = getFlatMap(servicesData.dataByCategory, 'slug');

    return {
        ...servicesData,
        icons: Object.entries(flatMap).reduce<Record<string, string | null>>(
            (result, [name, {icon}]) => ({...result, [name]: icon}),
            {},
        ),
    };
}
